import products from './products.js';
import Storage from './storage.js';
import _ from './translate.js';
import { textString, buttonString } from './texts.js';
import events from './event.js';
import Table from './table.js';
import Logger from './logger.js';

class StartOver {
    customizerContentDiv = null;
    wrapperDiv = null;

    constructor(customizerContentDiv) {
        this.customizerContentDiv = customizerContentDiv;
        if (!this.customizerContentDiv) {
            Logger.error('Start over step failed to load.');
            return;
        }
        this.init();
    }

    async init() {
        await this.createWrapper();
        await this.createContent();
        await this.addEventListeners();
    }

    async createWrapper() {
        if (this.wrapperDiv) {
            // If already initialized, just show the wrapper
            this.show();
            return;
        }
        this.wrapperDiv = document.createElement('div');
        this.wrapperDiv.classList.add('mscp-startover-wrapper');
        this.customizerContentDiv.appendChild(this.wrapperDiv);

    }

    async createContent() {
        // Stäng-knapp (samma mönster som upload-stegets close-knapp i popup.js)
        const closeButton = document.createElement('span');
        closeButton.classList.add('mscp-popup-close-button', 'mscp-startover-close-button', 'mscp-floating-button');
        closeButton.innerHTML = mindstore_object?.icon?.times;
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.hide();
            events.trigger('hidePopup');
        });
        this.wrapperDiv.appendChild(closeButton);

        const title = document.createElement('h2');
        title.textContent = textString('startover_title', "Do you want to continue editing your design or start a new one?");
        this.wrapperDiv.appendChild(title);

        const infoText = document.createElement('div');
        infoText.classList.add('mscp-startover-info-text');
        infoText.innerHTML = textString('startover_info_text', "If you choose to start a new design, your current design will be lost.");
        this.wrapperDiv.appendChild(infoText);

        const buttonWrapperDiv = document.createElement('div');
        buttonWrapperDiv.classList.add('mscp-startover-buttons');

        const proceedButton = buttonString('startover_title_proceed', "Continue Editing");
        const proceedButtonDiv = document.createElement('button');
        proceedButtonDiv.classList.add('mscp-startover-button', 'mscp-button');
        proceedButtonDiv.innerHTML = proceedButton;
        buttonWrapperDiv.appendChild(proceedButtonDiv);

        const newButton = buttonString('startover_title_new', "Start New Design");
        const newButtonDiv = document.createElement('button');
        newButtonDiv.classList.add('mscp-startover-button', 'mscp-button');
        newButtonDiv.innerHTML = newButton;
        buttonWrapperDiv.appendChild(newButtonDiv);

        this.wrapperDiv.appendChild(buttonWrapperDiv);

        proceedButtonDiv.addEventListener('click', () => {
            // events.trigger('showLoadingOverlay', 'presentation');
            events.trigger('updateCropSize');
            events.trigger('changeStep', 'paper');
            this.hide();
        });

        newButtonDiv.addEventListener('click', () => {
            Storage.startNewSession();
            // events.trigger('showLoadingOverlay', 'paper');
            events.trigger('reInitUpload');
            events.trigger('changeStep', 'upload');
            this.hide();
            // events.trigger('showLoadingOverlay');
        });
    }

    async addEventListeners() {

        // add event listener for step changes
        events.add('stepChanged', (step) => {
        });
        events.add('openStartOver', () => {
            this.show();
        });
    }

    hide() {
        if (this.customizerContentDiv) {
            this.customizerContentDiv.classList.remove('startover-active');
        }
    }

    show() {
        if (this.customizerContentDiv) {
            this.customizerContentDiv.classList.add('startover-active');
            // set scroll to top
            this.customizerContentDiv.scrollTop = 0;
        }
    }

}

export default StartOver;